import { render, staticRenderFns } from "./Infobox.vue?vue&type=template&id=9ff66f60&"
import script from "./Infobox.vue?vue&type=script&lang=ts&"
export * from "./Infobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports